<ng-container *ngIf="iconName">
    <div
        *ngIf="!useIonIcon"
        class="svg-icon {{ classes }}"
        [style.fill]="color && !useFillAsStrokeColor ? color : null"
        [style.border-color]="borderColor ? borderColor : color"
        [style.border-width]="borderWidth || null"
        [style.background]="backgroundColor || undefined"
        [innerHTML]="sanitizedSvgContent"
        [style.color]="!!color ? color : null"
        [style.--default-border-spacing]="!!borderSpacing ? borderSpacing + 'px' : undefined"
        [ngStyle]="!!size ? { width: size + 'px', height: size + 'px' } : null"
        [ngClass]="[
            !!sizeType ? 'icon-' + sizeType : '',
            useFillAsStrokeColor ? 'svg-icon-stroke-color' : '',
            roundBorder ? 'svg-icon-round-border' : ''
        ]"></div>
    <ion-icon
        *ngIf="useIonIcon"
        [icon]="svgPath"
        [style.fill]="color && !useFillAsStrokeColor ? color : null"
        class="svg-icon {{ classes }}"
        [style.color]="!!color ? color : null"
        [style.border-color]="borderColor ? borderColor : color"
        [style.border-width]="borderWidth || undefined"
        [style.background]="backgroundColor || undefined"
        [style.--default-icon-size]="!!size ? size + 'px' : '20px'"
        [style.--default-border-spacing]="!!borderSpacing ? borderSpacing + 'px' : undefined"
        [ngClass]="[
            !!sizeType ? 'icon-' + sizeType : '',
            useFillAsStrokeColor ? 'svg-icon-stroke-color' : '',
            roundBorder ? 'svg-icon-round-border' : ''
        ]" />
</ng-container>
